import { render } from "./AdministrationNav.vue?vue&type=template&id=1cf2738b&scoped=true"
import script from "./AdministrationNav.vue?vue&type=script&lang=js"
export * from "./AdministrationNav.vue?vue&type=script&lang=js"

import "./AdministrationNav.vue?vue&type=style&index=0&id=1cf2738b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf2738b"]])

export default __exports__